import { environment } from '@customer-portal/environments';

export const FEATURE_MANIFEST_URL = `${environment.translation.baseUrl}/features/features.json?${environment.translation.SAS}`;
// uncomment for local feature file testing
// export const FEATURE_MANIFEST_URL = '/assets/features/features.json';
export const FEATURE_INTERACTIONS_STORAGE_KEY = 'cp_feature_interactions';
export const TOUR_READY_TIMEOUT_MS = 8000;
export const TOUR_POLL_INTERVAL_MS = 150;
